import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { EmptyState } from '../common/EmptyState';
import { CardRow } from '../common/CardTable/CardRow';
import { CardCell } from '../common/CardTable/CardCell';

const StyledTableContainer = styled(TableContainer)(() => ({
    height: '100%',
    overflowX: 'visible',
}));

const COLUMN_WIDTHS = {
    strategyName: '100%',
};

const COLUMN_HEADERS = {
    strategyName: 'Strategy Name',
};

type ForcedRankingSearchResultsProps = {
    results: string[];
    searchTerm: string;
};

export const ForcedRankingSearchResults = ({
    results,
    searchTerm,
}: ForcedRankingSearchResultsProps): JSX.Element => {
    if (results.length === 0) {
        return (
            <EmptyState>
                <Typography gutterBottom align="center" variant="h6">
                    No Results Found
                </Typography>
                <Typography align="center" variant="body1">
                    {searchTerm
                        ? 'Try adjusting your search criteria'
                        : 'Enter a search term to get started'}
                </Typography>
            </EmptyState>
        );
    }

    return (
        <StyledTableContainer>
            <Table stickyHeader sx={{ pb: 8 }}>
                <TableHead>
                    <TableRow>
                        <TableCell align="left" width={COLUMN_WIDTHS.strategyName}>{COLUMN_HEADERS.strategyName}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {results.map((strategy) => (
                        <CardRow
                            hover
                            component={Link}
                            key={strategy}
                            to={`/design-concept-forced-ranking/${strategy}`}
                        >
                            <CardCell align="left" width={COLUMN_WIDTHS.strategyName}>{strategy}</CardCell>
                        </CardRow>
                    ))}
                </TableBody>
            </Table>
        </StyledTableContainer>
    );
};
